// extracted by mini-css-extract-plugin
export default {"errorText":"dialog_errorText__HkR0X","modal":"dialog_modal__3DMfT","header":"dialog_header__nx79L","headerIcon":"dialog_headerIcon__c2FZ0","title":"dialog_title__UtMTy"};